"use strict";
import React from "react";
import _ from "underscore";
import ReactUtils from "../../react_utils";
const bem = ReactUtils.makeBem("document-browser");
function explicitHeightStyle(props) {
  if (props.tmsObjects.length > 5) {
    return { height: 185 };
  } else {
    return {};
  }
}
export default function DropSelector(props) {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: bem("__assign-documents-selector"),
      style: explicitHeightStyle(props)
    },
    /* @__PURE__ */ React.createElement("span", { className: bem("__assign-documents-selector-label") }, props.label),
    _.map(props.tmsObjects, props.tmsObjectDetailsFunction)
  );
}
